<p>
    <b>{{counts}}</b> out of <b>50</b> tests correctly answered, which corresponds to <b>{{result}}</b> IQ.
</p>